export default "__VITE_ASSET__DMS8x80$__"